import { SanityClient } from '@sanity/client'

import { SiteMapDataModel } from '~/math-vault/types/sanityModel.types'

import { MathVaultActivity, MathVaultChestIdsMap, MathVaultRoom } from '~/types/math-vault'

import {
  getActivityGroq,
  getAllActivityGroq,
  getAllChestIds,
  getSiteMapChestData,
} from '~/shared/sanity/groq/math-vault'

import { AppLanguage } from '~/types/locale'

import sanityClient from './sanity-client'

class MathVaultSanity {
  private client: SanityClient

  public constructor() {
    this.client = sanityClient
  }

  public getJuniorDrillActivity(
    language: string,
    elevator: string,
    room: string,
    chest: string,
    tab: number,
    activityNumber: number,
  ): Promise<MathVaultActivity | null> {
    return this.client.fetch(getActivityGroq, { language, elevator, room, chest, tab, activityNumber })
  }

  public getJuniorDrillActivities(language: AppLanguage): Promise<MathVaultRoom[]> {
    return this.client.fetch(getAllActivityGroq, { language })
  }

  public getJuniorDrillChestIds(language: AppLanguage): Promise<MathVaultChestIdsMap[]> {
    return this.client.fetch(getAllChestIds, { language })
  }

  public getChestDataForSiteMap(language: AppLanguage): Promise<SiteMapDataModel[]> {
    return this.client.fetch<SiteMapDataModel[]>(getSiteMapChestData, { language })
  }
}

export const mathVaultSanity = new MathVaultSanity()
